import deepmerge from 'deepmerge';
import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import { ConfigurationExposeGroup } from '../interface';
import { ReadConfigurationDto } from '../generated-dto';
export class ConfigurationFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.goparrot_platform_service_notifier,
            },
        }, config), interceptors);
    }
    async get(merchantId, storeId) {
        return plainToInstanceWithLVS(ReadConfigurationDto, (await this.client.get(`/api/v3/merchants/${merchantId}/configurations`, {
            params: {
                storeId,
            },
        })).data, {
            groups: [ConfigurationExposeGroup.READ],
        });
    }
    async create(merchantId, data) {
        return plainToInstanceWithLVS(ReadConfigurationDto, (await this.client.post(`/api/v3/merchants/${merchantId}/configurations`, data)).data, {
            groups: [ConfigurationExposeGroup.READ],
        });
    }
    async patch(merchantId, uuid, data) {
        return plainToInstanceWithLVS(ReadConfigurationDto, (await this.client.patch(`/api/v3/merchants/${merchantId}/configurations/${uuid}`, data)).data, {
            groups: [ConfigurationExposeGroup.READ],
        });
    }
    async createNexmo(merchantId) {
        return plainToInstanceWithLVS(ReadConfigurationDto, (await this.client.post(`/api/v3/merchants/${merchantId}/configurations/custom/nexmo`)).data, {
            groups: [ConfigurationExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=ConfigurationFacade.js.map